(function () {
  function readData() {
    var el = document.querySelector("[data-rxp-data]");
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  var EN = ((document.documentElement.lang || "").toLowerCase().indexOf("en") === 0);
  var T = EN
    ? { add: "ADD TO CART", na: "NOT AVAILABLE", adding: "ADDING…", err: "Could not add to cart — please try again." }
    : { add: "IN DEN WARENKORB", na: "NICHT VERFÜGBAR", adding: "WIRD HINZUGEFÜGT…", err: "Konnte nicht in den Warenkorb legen — bitte nochmal versuchen." };

  function fmtEuro(n) {
    return EN ? ("€" + n.toFixed(2)) : ("€" + n.toFixed(2).replace(".", ","));
  }

  var SWATCH = { "Black": "#111114", "Navy": "#182338", "Forest Green": "#1c3326", "Maroon": "#3a1218", "Cardinal Red": "#8e1b2b", "White": "#f2f2ee", "Schwarz": "#111114", "Marine": "#182338", "Tannengrün": "#1c3326", "Weinrot": "#3a1218", "Rot": "#8e1b2b", "Weiß": "#f2f2ee", "Lila": "#5b3fa0", "Gold": "#b8922f", "Blau": "#182338", "Grün": "#1c3326", "Kardinalrot": "#8e1b2b" };
  var THEMES = {
    "Black": { bg: "#0b0b0d", bg2: "#131316", line: "#232328", glow: "rgba(230,230,225,.14)", a1: "rgba(124,92,255,.20)", a2: "rgba(230,57,70,.14)", g1: "#b9a8ff", g2: "#ffb199" },
    "Navy": { bg: "#0d1526", bg2: "#131c30", line: "#243352", glow: "rgba(140,170,255,.16)", a1: "rgba(90,140,255,.22)", a2: "rgba(60,220,255,.12)", g1: "#9db8ff", g2: "#8fe0ff" },
    "Forest Green": { bg: "#0d1f16", bg2: "#132a1e", line: "#24503a", glow: "rgba(150,255,190,.14)", a1: "rgba(70,220,140,.18)", a2: "rgba(220,255,120,.10)", g1: "#a8ffcf", g2: "#e8ffa8" },
    "Cardinal Red": { bg: "#1c0d10", bg2: "#26141a", line: "#4a2430", glow: "rgba(255,120,140,.14)", a1: "rgba(255,60,90,.20)", a2: "rgba(255,150,90,.12)", g1: "#ff9daa", g2: "#ffc99d" },
    "Maroon": { bg: "#1a0d11", bg2: "#241318", line: "#472530", glow: "rgba(255,150,170,.14)", a1: "rgba(255,80,110,.20)", a2: "rgba(255,170,90,.12)", g1: "#ff9db0", g2: "#ffcf9d" },
    "_default": { bg: "#0b0b0d", bg2: "#131316", line: "#232328", glow: "rgba(230,230,225,.14)", a1: "rgba(124,92,255,.20)", a2: "rgba(230,57,70,.14)", g1: "#b9a8ff", g2: "#ffb199" }
  };
  // German aliases so the per-color theme accent still applies when
  // product options use German color names (Farbe: Lila/Gold/Rot/Blau/Grün/Schwarz).
  THEMES["Schwarz"] = THEMES["Black"];
  THEMES["Blau"] = THEMES["Navy"];
  THEMES["Grün"] = THEMES["Forest Green"];
  THEMES["Rot"] = THEMES["Cardinal Red"];
  THEMES["Kardinalrot"] = THEMES["Cardinal Red"];
  THEMES["Lila"] = { bg: "#140d1f", bg2: "#1c1329", line: "#382a52", glow: "rgba(190,160,255,.16)", a1: "rgba(150,100,255,.22)", a2: "rgba(255,120,220,.12)", g1: "#c7b3ff", g2: "#ffb3e6" };
  THEMES["Gold"] = { bg: "#1f180d", bg2: "#292013", line: "#50401f", glow: "rgba(255,215,140,.16)", a1: "rgba(255,200,90,.20)", a2: "rgba(255,150,60,.12)", g1: "#ffdf9d", g2: "#ffbf7a" };
  // Neutral silvery accent for a plain white garment (keeps the dark page
  // chrome consistent with every other color, just a lighter accent tone).
  THEMES["Weiß"] = { bg: "#101012", bg2: "#17171a", line: "#2b2b30", glow: "rgba(230,230,230,.16)", a1: "rgba(210,210,220,.16)", a2: "rgba(160,160,170,.10)", g1: "#eaeaee", g2: "#cfcfd4" };

  // LYAM line: color option values are Gelato-generated placeholder
  // names ("Design Option N") plus "Deep Black" / "Off White" — none
  // of which matched the named-color map above, so every swatch button
  // rendered as the same flat gray circle. Map them to the actual wax
  // -seal colors used on each variant's product photo.
  SWATCH["Design Option 1"] = "#6b3fa8"; // lila wax seal
  SWATCH["Design Option 2"] = "#c81f2f"; // rot wax seal
  SWATCH["Design Option 3"] = "#1b2c52"; // navy wax seal
  SWATCH["Design Option 4"] = "#b8923a"; // gold wax seal
  SWATCH["Design Option 5"] = "#1f5c37"; // grün wax seal
  SWATCH["Design Option 6"] = "#16161a"; // schwarz wax seal
  SWATCH["Deep Black"] = "#141414";
  SWATCH["Off White"] = "#efece3";
  THEMES["Design Option 1"] = THEMES["Lila"];
  THEMES["Design Option 2"] = THEMES["Cardinal Red"];
  THEMES["Design Option 3"] = THEMES["Navy"];
  THEMES["Design Option 4"] = THEMES["Gold"];
  THEMES["Design Option 5"] = THEMES["Forest Green"];
  THEMES["Design Option 6"] = THEMES["Black"];
  THEMES["Deep Black"] = THEMES["Black"];

  // SIX SEALS re-sync (Gelato remade the product on new material): the
  // color option is now named "Siegel" with real German color names
  // instead of "Design Option N". Same six wax-seal colors, new labels.
  SWATCH["Rotes Siegel"] = "#c81f2f";
  SWATCH["Rotes Siegel (2)"] = "#c81f2f"; // duplicate value from the Gelato sync — same red until that's cleaned up
  SWATCH["Grünes Siegel"] = "#1f5c37";
  SWATCH["Goldenes Siegel"] = "#b8923a";
  SWATCH["Lila Siegel"] = "#6b3fa8";
  SWATCH["Schwarzes Siegel"] = "#16161a";
  SWATCH["Navy Siegel"] = "#1b2c52";
  THEMES["Rotes Siegel"] = THEMES["Cardinal Red"];
  THEMES["Rotes Siegel (2)"] = THEMES["Cardinal Red"];
  THEMES["Grünes Siegel"] = THEMES["Forest Green"];
  THEMES["Goldenes Siegel"] = THEMES["Gold"];
  THEMES["Lila Siegel"] = THEMES["Lila"];
  THEMES["Schwarzes Siegel"] = THEMES["Black"];
  THEMES["Navy Siegel"] = THEMES["Navy"];

  function initAll() {
    var data = readData();
    if (!data) return;

    try {
      var V = data.variants || [];
      var COLORS = [];
      var SIZES = [];
      var EXTRAS = [];
      V.forEach(function (v) {
        if (v.color && COLORS.indexOf(v.color) < 0) COLORS.push(v.color);
        if (v.size && SIZES.indexOf(v.size) < 0) SIZES.push(v.size);
        if (v.extra && EXTRAS.indexOf(v.extra) < 0) EXTRAS.push(v.extra);
      });

      var selColor = null;
      if (data.hasColor) {
        var darkPref = ["Schwarz", "Black", "Deep Black", "Design Option 6", "Schwarzes Siegel"];
        selColor = null;
        for (var dp = 0; dp < darkPref.length; dp++) {
          if (COLORS.indexOf(darkPref[dp]) >= 0) { selColor = darkPref[dp]; break; }
        }
        if (!selColor) selColor = COLORS[0];
      }
      var selSize = SIZES.indexOf("L") >= 0 ? "L" : SIZES[0];
      var selExtra = data.hasExtra ? EXTRAS[0] : null;

      function current() {
        for (var i = 0; i < V.length; i++) {
          if ((!data.hasColor || V[i].color === selColor) &&
              (!data.hasExtra || V[i].extra === selExtra) &&
              V[i].size === selSize) return V[i];
        }
        return null;
      }
      function applyTheme(name) {
        var th = THEMES[name] || THEMES._default;
        var r = document.documentElement.style;
        r.setProperty("--rx-bg", th.bg); r.setProperty("--rx-bg2", th.bg2);
        r.setProperty("--rx-line", th.line); r.setProperty("--rx-glow", th.glow);
        r.setProperty("--rx-a1", th.a1); r.setProperty("--rx-a2", th.a2);
        r.setProperty("--rx-g1", th.g1); r.setProperty("--rx-g2", th.g2);
      }
      function scrollGalTo(mediaId) {
        if (!mediaId) return;
        var fig = document.querySelector('.rxp-gal figure[data-mid="' + mediaId + '"]');
        if (!fig) return;
        fig.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
        // Safety net: a smooth scrollIntoView can be cut short (e.g. layout
        // shift from a lazy-loading image mid-animation), leaving the wrong
        // photo on screen. Re-issue an instant scrollIntoView once the
        // animation should have settled — if it already landed correctly
        // this is a no-op, and if it didn't, it snaps to the right spot.
        setTimeout(function () {
          fig.scrollIntoView({ behavior: "instant", block: "nearest", inline: "center" });
        }, 900);
      }
      function updateTotal() {
        var v = current();
        var totalEl = document.getElementById("rxp-btotal");
        var bsel = document.getElementById("rxp-bsize");
        if (!totalEl || !bsel || !data.partner || !v) return;
        var pid = parseInt(bsel.value, 10);
        var pv = null;
        (data.partner.variants || []).forEach(function (x) { if (x.id === pid) pv = x; });
        if (pv) totalEl.textContent = fmtEuro(v.priceNum + pv.priceNum);
      }
      function refresh() {
        var v = current();
        var buy = document.getElementById("rxp-buy");
        var buyM = document.querySelector(".rxp-buy-m");
        if (!buy) return;
        var el;
        if (v) {
          if ((el = document.getElementById("rxp-price"))) el.textContent = v.price;
          if ((el = document.getElementById("rxp-price-m"))) el.textContent = v.price;
          var c = document.getElementById("rxp-compare");
          var cm = document.getElementById("rxp-compare-m");
          var b = document.getElementById("rxp-launch");
          if (v.compare) {
            if (c) { c.textContent = v.compare; c.style.display = "inline"; }
            if (cm) { cm.textContent = v.compare; cm.style.display = "inline"; }
            if (b) b.style.display = "inline-block";
          } else {
            if (c) c.style.display = "none";
            if (cm) cm.style.display = "none";
            if (b) b.style.display = "none";
          }
          var ok = v.available;
          buy.disabled = !ok; if (buyM) buyM.disabled = !ok;
          buy.querySelector("span").textContent = ok ? T.add : T.na;
        } else {
          buy.disabled = true; if (buyM) buyM.disabled = true;
          buy.querySelector("span").textContent = T.na;
        }
        var cn = document.getElementById("rxp-colorname");
        if (cn && selColor) cn.textContent = selColor.toUpperCase();
        updateTotal();
      }

      var cwrap = document.getElementById("rxp-colors");
      if (cwrap && data.hasColor) {
        cwrap.innerHTML = "";
        COLORS.forEach(function (col) {
          var b = document.createElement("button");
          b.style.background = SWATCH[col] || "#333";
          b.setAttribute("aria-label", col);
          b.type = "button";
          if (col === selColor) b.classList.add("on");
          b.addEventListener("click", function () {
            cwrap.querySelectorAll("button").forEach(function (x) { x.classList.remove("on"); });
            b.classList.add("on"); selColor = col; applyTheme(col); refresh();
            var v = current();
            if (v) scrollGalTo(v.media);
          });
          cwrap.appendChild(b);
        });
      }
      var swrap = document.getElementById("rxp-sizes");
      if (swrap) {
        swrap.innerHTML = "";
        SIZES.forEach(function (sz) {
          var b = document.createElement("button");
          b.textContent = sz;
          b.type = "button";
          if (sz === selSize) b.classList.add("on");
          b.addEventListener("click", function () {
            swrap.querySelectorAll("button").forEach(function (x) { x.classList.remove("on"); });
            b.classList.add("on"); selSize = sz; refresh();
          });
          swrap.appendChild(b);
        });
      }
      var xwrap = document.getElementById("rxp-extra");
      if (xwrap && data.hasExtra) {
        xwrap.innerHTML = "";
        EXTRAS.forEach(function (ex) {
          var b = document.createElement("button");
          b.textContent = ex;
          b.type = "button";
          if (ex === selExtra) b.classList.add("on");
          b.addEventListener("click", function () {
            xwrap.querySelectorAll("button").forEach(function (x) { x.classList.remove("on"); });
            b.classList.add("on"); selExtra = ex; refresh();
            var v = current();
            if (v) scrollGalTo(v.media);
          });
          xwrap.appendChild(b);
        });
      }
      if (selColor) applyTheme(selColor);
      refresh();

      function addItems(items, btn) {
        var label = btn.querySelector("span");
        var orig = label.textContent;
        label.textContent = T.adding;
        fetch(data.cartAddUrl + ".js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: items })
        }).then(function (r) { if (!r.ok) throw 0; return r.json(); })
          .then(function () { window.location = data.cartUrl; })
          .catch(function () {
            label.textContent = orig;
            alert(T.err);
          });
      }
      var buyBtn = document.getElementById("rxp-buy");
      if (buyBtn && !buyBtn.dataset.rxB) {
        buyBtn.dataset.rxB = "1";
        buyBtn.addEventListener("click", function () {
          var v = current();
          if (v && v.available) addItems([{ id: v.id, quantity: 1 }], buyBtn);
        });
      }
      var buyM = document.querySelector(".rxp-buy-m");
      if (buyM && !buyM.dataset.rxB) {
        buyM.dataset.rxB = "1";
        buyM.addEventListener("click", function () {
          var v = current();
          if (v && v.available) addItems([{ id: v.id, quantity: 1 }], buyM);
        });
      }
      var bsel = document.getElementById("rxp-bsize");
      if (bsel && !bsel.dataset.rxB) {
        bsel.dataset.rxB = "1";
        bsel.addEventListener("change", updateTotal);
      }
      var both = document.getElementById("rxp-buyboth");
      if (both && !both.dataset.rxB) {
        both.dataset.rxB = "1";
        both.addEventListener("click", function () {
          var v = current();
          var bs = document.getElementById("rxp-bsize");
          if (!v || !v.available || !bs) return;
          addItems([{ id: v.id, quantity: 1 }, { id: parseInt(bs.value, 10), quantity: 1 }], both);
        });
      }
    } catch (e) { if (window.console) console.error("rxp:", e); }

    // ===== Reveals (Bundle, Accordion, Related) =====
    try {
      var rev = document.querySelectorAll(".rx-reveal:not(.in)");
      if (rev.length) {
        if ("IntersectionObserver" in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (en) {
              if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); }
            });
          }, { threshold: .12 });
          rev.forEach(function (el) { io.observe(el); });
        }
        setTimeout(function () { document.querySelectorAll(".rx-reveal:not(.in)").forEach(function (el) { el.classList.add("in"); }); }, 2500);
      }
    } catch (e) { if (window.console) console.error("rxp fx:", e); }
  }

  window.rxProductInit = initAll;
  if (document.readyState !== "loading") initAll();
  else document.addEventListener("DOMContentLoaded", initAll);
  if (!window.__rxpListener) {
    window.__rxpListener = true;
    document.addEventListener("shopify:section:load", function () { initAll(); });
  }
})();
